enum FetchStatus {
  none = 'none',
  loading = 'loading',
  loaded = 'loaded',
}

export default FetchStatus;
